<template>
  <div class="meetingRecordList">
    <!-- 筛选 -->
    <div class="filters">
      <el-form :inline="true" label-suffix=":">
        <!-- 赛事类别select -->
        <el-form-item :label="$t('lang.lab_competeCategory')">
          <el-select v-model="competeCategoryId" :placeholder="$t('lang.pla_pleaseSelect')+$t('lang.lab_competeCategory')">
            <el-option
              v-for="(item,index) in categoryNames"
              :key="index"
              :value="item.id"
              :label="item.categoryName">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 比赛项select -->
        <el-form-item :label="$t('lang.lab_competeEvent')">
          <el-select v-model="eventId" :placeholder="$t('lang.pla_pleaseSelect')+$t('lang.lab_competeEvent')">
            <el-option
              v-for="(item,index) in eventNames"
              :key="index"
              :value="item.id"
              :label="item.eventName">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 组别select -->
        <el-form-item :label="$t('lang.lab_competeGroup')">
          <el-select v-model="groupId" :placeholder="$t('lang.pla_pleaseSelect')+$t('lang.lab_competeGroup')">
            <el-option
              v-for="(item,index) in groupNames"
              :key="index"
              :value="item.id"
              :label="item.groupName">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 年龄段select -->
        <el-form-item :label="$t('lang.lab_competeAgeGroup')">
          <el-select v-model="ageGroupId" :placeholder="$t('lang.pla_pleaseSelect')+$t('lang.lab_competeAgeGroup')">
            <el-option
              v-for="(item,index) in ageNames"
              :key="index"
              :value="item.id"
              :label="item.ageGroupName">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 查询 -->
        <el-button type="primary" @click="onSearch(true,true)">{{$t('lang.btn_search')}}</el-button>
        <!-- 重置 -->
        <el-button type="primary" @click="onClear">{{$t('lang.btn_reset')}}</el-button>
      </el-form>
    </div>
    <!-- 表格 -->
    <el-card>
      <!-- 新增 -->
      <el-button type="primary" slot="header" @click="onAdd">{{$t('lang.btn_add')}}</el-button>
      <!-- 删除 -->
      <el-button type="primary" slot="header" @click="onDelete">{{$t('lang.btn_delete')}}</el-button>
      <el-table
        class="wid100"
        :data="tableData"
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
        @sort-change="changeTableSort"
      >
        <!-- 复选框 -->
        <el-table-column type="selection" align="center" width="55"></el-table-column>
        <!-- 赛事类别 -->
        <el-table-column prop="competeCategoryName" :label="$t('lang.lab_competeCategory')" :sortable="'custom'"></el-table-column>
        <!-- 比赛项 -->
        <el-table-column prop="itemEventName" :label="$t('lang.lab_competeEvent')" :sortable="'custom'"></el-table-column>
        <!-- 组别 -->
        <el-table-column prop="itemGroupName" :label="$t('lang.lab_competeGroup')" :sortable="'custom'"></el-table-column>
        <!-- 年龄段 -->
        <el-table-column prop="itemAgeName" :label="$t('lang.lab_competeAgeGroup')" :sortable="'custom'"></el-table-column>
        <!-- 操作 -->
        <el-table-column prop="operation" :label="$t('lang.lab_operation')" fixed="right" >
          <template slot-scope="scope">
            <el-button @click="onDetail(scope.row.id)">{{$t('lang.btn_detail')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      />
    </el-card>
    <!-- 新增编辑 -->
    <el-dialog 
      :title="isTitle"
      :visible.sync="isShow" 
      :close-on-click-modal="false"
      :destroy-on-close="true"
      center
      top="130px"
      width="600px"
      v-if="isShow"
      @close="handleDialogClosed">
      <el-form :model="form" :rules="rules" ref="form" label-width="120px" label-suffix=":">
        <!-- 赛事类别 -->
        <el-form-item prop="competeCategoryId" :label="$t('lang.lab_competeCategory')">
          <el-select v-model="form.competeCategoryId" :placeholder="$t('lang.pla_pleaseSelect')+$t('lang.lab_competeCategory')">
            <el-option
              v-for="(item,index) in categoryNames"
              :key="index"
              :value="item.id"
              :label="item.categoryName">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 比赛项 -->
        <el-form-item prop="eventId" :label="$t('lang.lab_competeEvent')">
          <el-select v-model="form.eventId" :placeholder="$t('lang.pla_pleaseSelect')+$t('lang.lab_competeEvent')">
            <el-option
              v-for="(item,index) in eventNames"
              :key="index"
              :value="item.id"
              :label="item.eventName">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 组别 -->
        <el-form-item prop="groupId" :label="$t('lang.lab_competeGroup')">
          <el-select v-model="form.groupId" :placeholder="$t('lang.pla_pleaseSelect')+$t('lang.lab_competeGroup')">
            <el-option
              v-for="(item,index) in groupNames"
              :key="index"
              :value="item.id"
              :label="item.groupName">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 年龄段 -->
        <el-form-item prop="ageGroupId" :label="$t('lang.lab_competeAgeGroup')">
          <el-select v-model="form.ageGroupId" :placeholder="$t('lang.pla_pleaseSelect')+$t('lang.lab_competeAgeGroup')">
            <el-option
              v-for="(item,index) in ageNames"
              :key="index"
              :value="item.id"
              :label="item.ageGroupName">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 显示名次数 -->
        <el-form-item prop="displayNum" :label="$t('lang.lab_displayNum')">
          <input style="display: none"/>
          <el-input v-model="form.displayNum" :placeholder="$t('lang.pla_pleaseInput')+$t('lang.lab_displayNum')" maxlength="5" @input="keyDisplayNum"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="toCancel">{{$t('lang.btn_cancel')}}</el-button>
        <el-button type="primary" @click="toSave('form')" :disabled="isDisabled">{{$t('lang.btn_confirm')}}</el-button>
      </div>
    </el-dialog> 
  </div>
</template>

<script>
/**
 *@ClassName:meetingRecordList
 *@Description:赛会记录
 *@author:宋莎
 *@Copyright:美再晨
 *@date:2020-07-16
 */
export default {
  name: '',
  components: {},
  data() {
    return {
      isShow: false, // 新增编辑dialog的显示控制
      isTitle: this.$i18n.t('lang.btn_add'), // 新增编辑dialog的title
      isDisabled: true, // 确定按钮置灰
      /* 赛会记录列表变量 */
      multipleSelection: [], // 复选框
      pageNum: 1, // 页数
      pageSize: 10, // 每页显示数量
      total: 0, // 数据总数
      categoryNames: [], // 赛事类别下拉list
      eventNames: [], // 比赛项下拉list
      groupNames: [], // 组别下拉list
      ageNames: [], // 年龄段下拉list
      competeCategoryId: '', // 筛选-赛事类别
      eventId: '', // 筛选-比赛项
      groupId: '', // 筛选-组别
      ageGroupId: '', // 筛选-年龄段
      sortName: '', // 升序/降序
      sortFieldName: '', // 排序字段
      tableData: [], // 列表数据
      /* 记忆筛选项值 */
      competeCategoryId_bak: '', // 备份-赛事类别
      eventId_bak: '', // 备份-比赛项
      groupId_bak: '', // 备份-组别
      ageGroupId_bak: '', // 备份-年龄段
      /* 赛会记录详情(新建)变量 */
      rules: {
        competeCategoryId: [{ required: true, message: this.$i18n.t('lang.pla_pleaseSelect') + this.$i18n.t('lang.lab_competeCategory'), trigger: 'change' }],
        eventId: [{ required: true, message: this.$i18n.t('lang.pla_pleaseSelect') + this.$i18n.t('lang.lab_competeEvent'), trigger: 'change' }],
        groupId: [{ required: true, message: this.$i18n.t('lang.pla_pleaseSelect') + this.$i18n.t('lang.lab_competeGroup'), trigger: 'change' }],
        ageGroupId: [{ required: true, message: this.$i18n.t('lang.pla_pleaseSelect') + this.$i18n.t('lang.lab_competeAgeGroup'), trigger: 'change' }],
        displayNum: [{ required: true, message: this.$i18n.t('lang.pla_pleaseInput') + this.$i18n.t('lang.lab_displayNum'), trigger: 'blur' }],
      },
      form: {
        id: '',
        competeCategoryId: '',
        eventId: '',
        groupId: '',
        ageGroupId: '',
        displayNum: '',
      }, // 详细数据
    }
  },
  computed: {},
  watch: {
    form: {
      handler(newVal, oldVal) {
        let tempRule = JSON.stringify(newVal)
        if (tempRule === this.saveData) {
          // 没变
          this.isDisabled = true
        } else {
          // 变了
          this.isDisabled = false
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // 获取赛会记录列表数据
    getData() {
      let params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      this.$postJson('/competeRecord/filterCompeteRecord', params).then(
        res => {
          if (res && res.code === 200) {
            this.total = res.data.total
            this.tableData = res.data.list
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 获取赛事类别下拉list
    getCategoryList() {
      this.$get(`/competeCategory/category?status=1`).then(
        res => {
          if (res && res.code === 200) {
            this.categoryNames = res.data.list
            let newValue = {
              id: '',
              categoryName: this.$i18n.t('lang.pla_pleaseSelect') + this.$i18n.t('lang.lab_competeCategory')
            }
            this.categoryNames.unshift(newValue)  
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 获取比赛项下拉list
    getEventList() {
      this.$get('/itemEvent/itemEvent').then(
        res => {
          if (res && res.code === 200) {
            this.eventNames = res.data.list
            let newValue = {
              id: '',
              eventName: this.$i18n.t('lang.pla_pleaseSelect') + this.$i18n.t('lang.lab_competeEvent')
            }
            this.eventNames.unshift(newValue)  
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 获取组别下拉list
    getGroupList() { 
      this.$get('/itemGroup/itemGroup').then(
        res => {
          if (res && res.code === 200) {
            this.groupNames = res.data.list
            let newValue = {
              id: '',
              groupName: this.$i18n.t('lang.pla_pleaseSelect') + this.$i18n.t('lang.lab_competeGroup')
            }
            this.groupNames.unshift(newValue)  
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 获取年龄段下拉list
    getAgeList() {
      this.$get('/itemAge/itemAge').then(
        res => {
          if (res && res.code === 200) {
            this.ageNames = res.data.list
            let newValue = {
              id: '',
              ageGroupName: this.$i18n.t('lang.pla_pleaseSelect') + this.$i18n.t('lang.lab_competeAgeGroup')
            }
            this.ageNames.unshift(newValue)  
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 查询
    onSearch(flag, isSearch) { 
      if (flag) {
        this.pageNum = 1
      }
      if (isSearch) {
        // 记忆筛选项值
        this.competeCategoryId_bak = this.competeCategoryId
        this.eventId_bak = this.eventId
        this.groupId_bak = this.groupId
        this.ageGroupId_bak = this.ageGroupId
      } else { 
        // 筛选项正确显示
        this.competeCategoryId = this.competeCategoryId_bak
        this.eventId = this.eventId_bak
        this.groupId = this.groupId_bak
        this.ageGroupId = this.ageGroupId_bak
      }
      let params = {
        competeCategoryId: this.competeCategoryId,
        eventId: this.eventId,
        groupId: this.groupId,
        ageGroupId: this.ageGroupId,
        sortName: this.sortName,
        sortFieldName: this.sortFieldName,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      this.$postJson('/competeRecord/filterCompeteRecord', params).then(
        res => {
          if (res && res.code === 200) {
            this.total = res.data.total
            this.tableData = res.data.list
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )      
    },
    // 重置
    onClear() {
      this.competeCategoryId = ''
      this.eventId = ''
      this.groupId = ''
      this.ageGroupId = ''
      this.competeCategoryId_bak = ''
      this.eventId_bak = ''
      this.groupId_bak = ''
      this.ageGroupId_bak = ''
      this.sortName = ''
      this.sortFieldName = ''
      this.pageNum = 1
      this.getData()
    },
    // 新增
    onAdd() {
      console.log('onAdd')
      this.isTitle = this.$i18n.t('lang.btn_add')
      this.form.id = ''
      this.form.competeCategoryId = ''
      this.form.eventId = ''
      this.form.groupId = ''
      this.form.ageGroupId = ''
      this.form.displayNum = ''
      this.isShow = true
    },
    // 删除
    onDelete() {
      console.log('onDelete')
      var array = []
      for (let index = 0; index < this.multipleSelection.length; index++) {
        array.push(this.multipleSelection[index].id)
      }
      if (array.length === 0) {
        this.$message.error(this.$i18n.t('lang.warning_selectOneDelete'))
        return        
      }
      let loading = this.$loading()
      this.$confirm(this.$i18n.t('lang.lab_isDelete'), this.$i18n.t('lang.lab_prompt'),
        {
          confirmButtonText: this.$i18n.t('lang.btn_confirm'),
          cancelButtonText: this.$i18n.t('lang.btn_cancel'),
          type: 'warning'
        }
      ).then(() => {
          this.$delete(`/competeRecord/record/${array}`).then(
            res => {
              loading.close()
              if (res && res.code === 200) {
                this.$message({
                  type: 'success',
                  message: this.$i18n.t('lang.lab_delSuccess')
                })
                // 更新tableData
                this.onSearch(true, false)
              } else {
                this.$message.error(res.message)
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )   
        })
        .catch(() => {
          loading.close()
          this.$message({
            type: 'info',
            message: this.$i18n.t('lang.lab_delCancel')
          })
        })  
    },
    // 查看
    onDetail(id) {
      console.log('onDetail', id)
      this.$router.push({ name: 'meetingRecordDetail', query: { id: id } })
    },
    // 保存
    toSave(formName) {
      console.log('toSave')
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = this.form
          this.$postJson('/competeRecord/record', params).then(
            res => {
              if (res && res.code === 200) {
                this.$message({
                  type: 'success',
                  message: this.$i18n.t('lang.lab_modifySuccess')
                })
                this.handleDialogClosed()
                // 更新列表
                this.onSearch(true, false)
              } else {
                this.$message.error(res.message)
              }
            },
            error => {
              this.$message.error(error)
            }
          )
        } else {
          return false
        }
      })
    },
    // 取消
    toCancel() {
      console.log('toCancel')
      this.isShow = false
      this.$refs.form.clearValidate()
      this.form.id = ''
      this.form.competeCategoryId = ''
      this.form.eventId = ''
      this.form.groupId = ''
      this.form.ageGroupId = ''
      this.form.displayNum = ''
    },
    // 监听关闭'新建编辑'dialog
    handleDialogClosed() {
      console.log('handleDialogClosed')
      this.isShow = false
      this.$refs.form.clearValidate()
      this.form.id = ''
      this.form.competeCategoryId = ''
      this.form.eventId = ''
      this.form.groupId = ''
      this.form.ageGroupId = ''
      this.form.displayNum = ''
    },
    // 翻页
    handleCurrentChange(val) {
      this.pageNum = val
      this.onSearch(false, false)
    },
    // 切换每页显示多少数据
    handleSizeChange(val) {
      this.pageNum = 1
      this.pageSize = val
      this.onSearch(false, false)
    },
    // 表格斑马
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // 多选框
    handleSelectionChange(val) {
      console.log('多选', val)
      this.multipleSelection = val
    },
    // 监听表格排序
    changeTableSort(column) {
      console.log('排序', column)
      // 将排序传给后台
      this.sortName = column.order
      this.sortFieldName = column.prop
      this.onSearch(true, false)
    },
    // 显示名字数 输入限制
    keyDisplayNum() {
      // 仅保留数字
      this.form.displayNum = this.form.displayNum.replace(/[^\d]/g, '') 
      // 首位是0的话去掉
      if (this.form.displayNum.indexOf('.') < 0 && this.form.displayNum !== '') { 
        this.form.displayNum = parseFloat(this.form.displayNum)
      }      
    }
  },
  created() {
    this.getData()
    this.getCategoryList()
    this.getEventList()
    this.getGroupList()
    this.getAgeList()
  },
  mounted() {}
}
</script>

<style lang='scss'>
</style>
